module.exports = __webpack_public_path__ + "static/img/25b.159171e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/25b.jpg
// module id = HabU
// module chunks = 0